import { Button } from 'native-base'
import { StyleProp, ViewStyle } from 'react-native'

import { Icon } from './Icon'

import { IconNames } from '~types/icon'
type AbsoluteButtonWithIconType = {
  iconName: IconNames
  style?: StyleProp<ViewStyle>
  onClick: () => void
}
export const AbsoluteButtonWithIcon = ({
  iconName,
  style,
  onClick,
}: AbsoluteButtonWithIconType) => {
  return (
    <Button
      justifyContent="center"
      alignItems="center"
      borderRadius="full"
      zIndex="20"
      background="white"
      position="absolute"
      width="12"
      height="12"
      style={style}
      onPress={onClick}
    >
      <Icon color="black" name={iconName} size={25} />
    </Button>
  )
}
